import { createFileRoute } from '@tanstack/react-router';
import { PartnerOrganizationPage } from '@/pages/partner/PartnerOrganizationPage';

export const Route = createFileRoute('/partner/organization/')({
  component: PartnerOrganizationPage
});
